/**
 * @date 2021/12/30
 * @author ponychoker
 * @tip vue-cli重构版
 */

import Vue from 'vue'

/**
 * 代码兼容性
 * 一切为了ie
 */
import 'babel-polyfill'

/**
 * 引用 vue
 * 引用 需要挂载的DOM
 */
import App from './views/App.vue'

/**
 * vue-router路由
 * 引用路由配置文件
 */
import router from './router/index' // 引用路由配置文件

/**
 * vuex状态管理
 * 引用vuex的store
 */
import store from './vuex'

/**
 * 所有插件引入的入口
 */
import './plugins/index'

// 所有组件引入入口
import './components/index'

/**
 * mixins
 * vue全局变量和方法
 */
import mixins from './lib/mixins'
Vue.mixin(mixins)
import '@/icons' // icon
/**
 * 受不了iview了（也就是ppui）引入element
 */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

/**
 *  国际化相关
 */

import i18n from './i18n/i18n'

/**
 * 导入所有sass文件，重构完我也不知道旧框架怎么导的了
 */
import '@/style/web-theme.scss'
import '@/style/custom.scss'
import '@/style/animate.scss'
import '@/style/common.scss'
import { initMonitor } from '@/monitor'

/**
 *  vue调试模式
 */

Vue.config.devtools = process.env.NODE_ENV !== 'production'

Vue.prototype.$bus = new Vue()
initMonitor()

Vue.prototype.$handleResponse = (res) => {
	const { code, data, msg } = res
	if (code === 200) {
		return data || true
	} else {
		Vue.prototype.$message.error(msg)
		return false
	}
}

const vueTemp = new Vue({
	el: '#app',
	router,
	store,
	i18n,
	created() {
		this.getTimeZone()
	},
	render: h => h(App)
})
window.vm = vueTemp
export default vueTemp
